import camelCase from "lodash/camelCase";
export function formatID(label, number) {
    return `${label}${number}`;
}
export function schemaToFields(schema) {
    return schema.map((f, i) => (Object.assign(Object.assign({}, f), { id: formatID(f.name, i) })));
}
export const getUniqueFields = (fields) => {
    const fieldMap = new Map();
    const results = [];
    for (const field of fields) {
        const name = camelCase(field.name);
        const fieldMapValue = fieldMap.get(name);
        if (fieldMapValue === undefined) {
            fieldMap.set(name, 1);
            results.push(Object.assign(Object.assign({}, field), { id: name }));
        }
        else {
            const newName = `${name}${fieldMapValue}`;
            fieldMap.set(name, fieldMapValue + 1);
            const newField = Object.assign(Object.assign({}, field), { id: newName });
            results.push(newField);
        }
    }
    return results;
};
const javascriptReservedWords = [
    "delete",
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "false",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "null",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "true",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with"
];
const isReservedWord = (word) => {
    return javascriptReservedWords.includes(word);
};
export const getUniqueActions = (actions) => {
    const actionMap = new Map();
    const results = [];
    for (const action of actions) {
        const title = camelCase(action.title);
        const actionMapValue = actionMap.get(title);
        if (actionMapValue === undefined) {
            actionMap.set(title, 1);
            const addedZero = isReservedWord(title) ? "0" : "";
            results.push(Object.assign(Object.assign({}, action), { id: `${title}${addedZero}` }));
        }
        else {
            const newTitle = `${title}${actionMapValue}`;
            actionMap.set(title, actionMapValue + 1);
            const newAction = Object.assign(Object.assign({}, action), { id: newTitle });
            results.push(newAction);
        }
    }
    return results;
};
